export const BOOK_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/book.svg";
export const BALLOON_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/balloon.svg";
export const BIRD_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/bird.svg";
export const CALENDAR_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/calendar.svg";
export const CLOVER_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/clover.svg";
export const CRAYONS_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/crayons.svg";
export const DATA_FLOW_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/data-flow.svg";
export const FENCE_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/fence.svg";
export const GRILL_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/grill.svg";
export const HAND_DRILL_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/hand-drill.svg";
export const HAT_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/hat.svg";
export const INTERNET_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/internet.svg";
export const LADYBUG_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/ladybug.svg";
export const LEAVES_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/leaves.svg";
export const MEDICINE_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/medicine.svg";
export const NEST_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/nest.svg";
export const SHUTTLECOCK_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/shuttlecock.svg";
export const SPADE_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/spade.svg";
export const STATISTICS_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/statistics.svg";
export const SUN_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/sun.svg";
export const TREE_ICON =
  "https://static-assets.codecademy.com/skillpaths/react-redux/redux-quiz-app/tree.svg";

export const ALL_ICONS = [
  {
    url: BOOK_ICON,
    name: "Book",
  },
  {
    url: BALLOON_ICON,
    name: "Balloon",
  },
  {
    url: BIRD_ICON,
    name: "Bird",
  },
  {
    url: CALENDAR_ICON,
    name: "Calendar",
  },
  {
    url: CLOVER_ICON,
    name: "Clover",
  },
  {
    url: CRAYONS_ICON,
    name: "Crayons",
  },
  {
    url: DATA_FLOW_ICON,
    name: "Data",
  },
  {
    url: FENCE_ICON,
    name: "Fence",
  },
  {
    url: GRILL_ICON,
    name: "Grill",
  },
  {
    url: HAND_DRILL_ICON,
    name: "Hand",
  },
  {
    url: HAT_ICON,
    name: "Hat",
  },
  {
    url: INTERNET_ICON,
    name: "Internet",
  },
  {
    url: LADYBUG_ICON,
    name: "Ladybug",
  },
  {
    url: LEAVES_ICON,
    name: "Leaves",
  },
  {
    url: MEDICINE_ICON,
    name: "Medicine",
  },
  {
    url: NEST_ICON,
    name: "Nest",
  },
  {
    url: SHUTTLECOCK_ICON,
    name: "Shuttlecock",
  },
  {
    url: SPADE_ICON,
    name: "Spade",
  },
  {
    url: STATISTICS_ICON,
    name: "Statistics",
  },
  {
    url: SUN_ICON,
    name: "Sun",
  },
  {
    url: TREE_ICON,
    name: "Tree",
  },
];
